import { ViewportType } from '../../utils/viewport/getViewportType';
import type { AppConfig, MenuItemConfig } from '../../config';
import type { SetRequired } from '../../utils/types';

export interface MenuItem extends Omit<MenuItemConfig, 'link' | 'id'> {
  link?: MenuItemConfig['link'];
  id?: MenuItemConfig['id'];
  icon?: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
}

export type MainMenuItem = SetRequired<MenuItem, 'iconName'>;

export interface MenuItems {
  mainMenuItems: MainMenuItem[];
  subMenuItems: MenuItem[];
}

export const getDesktopMenuItems = (config: AppConfig): MenuItems => {
  const limit = config.desktopMenuItemsCount;
  const items = config.menuItems || [];

  return {
    mainMenuItems: items.slice(0, limit) as MainMenuItem[],
    subMenuItems: items.slice(limit),
  };
};

export const getMobileMenuItems = (config: AppConfig): MenuItems => {
  const limit = config.mobileMenuItemsCount;
  const items = config.menuItems || [];
  const mainMenuItems = items
    .filter(({ iconName }) => !!iconName)
    .slice(0, limit);

  return {
    mainMenuItems: mainMenuItems as MainMenuItem[],
    subMenuItems: items.filter((i) => !mainMenuItems.includes(i)),
  };
};

/**
 * Returns first menu items to render in the header or mobile bottom menu
 */
export const getMenuItems = (
  config: AppConfig,
  viewport: ViewportType
): MenuItems =>
  viewport === ViewportType.DESKTOP
    ? getDesktopMenuItems(config)
    : getMobileMenuItems(config);
